import "./Cursos.scss";

import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import { getApiCourses } from "../../services/apiCourse";
import { types } from "../../constants/constants";
import { TableProps } from "../../components/Table/TableTypes";
import Table from "../../components/Table/Table";
import Button from "../../components/Button/Button";
import dayjs from "dayjs";
import 'dayjs/locale/es' // import locale


const Cursos = (): React.ReactElement =>{  
  const navigate = useNavigate();
  const [menuProps, setMenuProps] = useState<MenuProps>(defaultMenuProps);
  const [courses, setCourses] = useState<TableProps['items']>([]);
  const [limit, setLimit] = useState<number>(types.PAGE_SIZE);
  const [offset, setOffset] = useState<number>(0);
  const [totalCourses, setTotalCourses] = useState<number>(0);
  const [actions, setActions] = useState<TableProps["actions"]>([]);
  const [sortDirection, setSortDirection] = useState<number>(1);
  const [sortBy, setSortBy] = useState<string>('created_at');

  useEffect(() => {
    getCourses();

    setActions([
      {
        name : 'Editar',
        onClick : editAction,
        icon : 'pencil' 
      }/*,
      {
        name : 'Borrar',
        onClick : deleteAction,
        icon : 'deleteIcon' 
      }*/
    ])
  }, []);

  useEffect(() => {
    getCourses();
  }, [sortBy, sortDirection]);

  const getCourses = async (): Promise<void> => {
    const result: object = getApiCourses(
      {
        limit: limit,
        offset: offset,
        sortBy: sortBy,
        sortDirection: sortDirection
      }
    ).then(async (response: any) => {
      setTotalCourses(response.total)

      const resultsCourses: TableProps['items'] = await Promise.all(response.courses && response.courses.map((course: any, index: number) =>{
        return [
          { name: '#', value : index + 1 },
          { name: 'Id', value : course._id },
          { name: 'Título', value : course.title, sortable: true, index: 'title' },
          { name: 'Profesor', value : course.teacher, sortable: true, index: 'teacher' },
          { name: 'Precio', value : course.price ? `${course.price.toString().replace('.', ',')}€` : '--', sortable: true, index: 'price', className: 'text-center' },
          { name: 'Ventas', value : course.sales, className: 'text-center' },
          { name: 'Visualizaciones', value : course.views, sortable: true, index: 'views', className: 'text-center' },
        ]
      }));
      setCourses(resultsCourses);
    })
    .catch((error: any) => {
      console.log(error.message);
      setCourses([])
    });
  }

  const loadMoreCourses = async (): Promise<void> => {
    const offsetPage = offset + limit;
    
    const result: object = getApiCourses(
      {
        limit: limit,
        offset: offsetPage,
        sortBy: sortBy,
        sortDirection: sortDirection
      }
    ).then(async (response: any) => {
      const resultsCourses: TableProps['items'] = await Promise.all(response.courses && response.courses.map((course: any, index: number) =>{
        return [
          { name: '#', value : index + offsetPage + 1 },
          { name: 'Id', value : course._id },
          { name: 'Título', value : course.title, sortable: true, index: 'title' },
          { name: 'Profesor', value : course.teacher, sortable: true, index: 'teacher' },
          { name: 'Precio', value : course.price ? `${course.price.toString().replace('.', ',')}€` : '--', sortable: true, index: 'price', className: 'text-center' },
          { name: 'Ventas', value : course.sales, className: 'text-center' },
          { name: 'Visualizaciones', value : course.views, sortable: true, index: 'views', className: 'text-center' },
        ]
      }));
      
      const arrayCourses = courses.concat(resultsCourses)
      setOffset(offsetPage);
      setCourses(arrayCourses);
    })
    .catch((error: any) => {
      console.log(error.message);
      setCourses([])
    });
  }

  const editAction = (id: string): void => {
    navigate(`/cursos/${ id }`);
  }

  const deleteAction = (id: string): void => {
    alert('delete');
  }

  const doSortBy = (field : string): void => {
    setOffset(0)
    setSortBy(field)
    setSortDirection(sortDirection === 1 ? -1 : 1)
  }
  
  return(
    <React.Fragment>
      <div id="menu">
        <Menu items={ menuProps.items } />
      </div>

      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Cursos</h1>
          <Button className={'btn-orangebg ms-auto me-3'} value={'Añadir curso'} onClick={ () => { navigate('/cursos/crear') } } />
          <span>Total registros: { totalCourses }</span>
        </header>
        { courses && courses.length ?
          <Table items={ courses } actions={actions} doSortBy={doSortBy} />
        :
          <p>No hay cursos</p>
        }

        { totalCourses > courses.length ?
          <div className="row mt-4">
            <div className="col-12 col-md-4 offset-md-4">
              <Button className={'btn-white m-auto'} value={'Cargar más'} onClick={ () => { loadMoreCourses() } } />
            </div>
          </div>
        : null }
      </div>
    </React.Fragment>
  )
}

export default Cursos;